import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-email-plus-outline.component',
  templateUrl: './icon-email-plus-outline.component.html',
  styleUrl: './icon-email-plus-outline.component.scss',
  standalone: false,
})
export class IconEmailPlusOutlineComponent {
  @Input() tooltip?: string;
}
